export default __webpack_public_path__ + "images/KD.20afbbf.png";